// extracted by mini-css-extract-plugin
export var collapser = "StickyNav-module--collapser--388a3";
export var current = "StickyNav-module--current--1a0e6";
export var headingButton = "StickyNav-module--heading-button--abc53";
export var headingButtonClosed = "StickyNav-module--heading-button-closed--e3253";
export var headingButtonOpen = "StickyNav-module--heading-button-open--45321";
export var list = "StickyNav-module--list--482c8";
export var stick = "StickyNav-module--stick--6aac9";
export var wrap = "StickyNav-module--wrap--8b683";